import { render, staticRenderFns } from "./OtherSection.vue?vue&type=template&id=0fb3a9a1&scoped=true"
import script from "./OtherSection.vue?vue&type=script&lang=js"
export * from "./OtherSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb3a9a1",
  null
  
)

export default component.exports